(()=>{
  const $=(s,r=document)=>r.querySelector(s);
  const $$=(s,r=document)=>[...r.querySelectorAll(s)];
  const text=(el,v)=>{if(el)el.textContent=v};

  function homeCro(){
    const loader=$('#loader');
    if(loader) requestAnimationFrame(()=>loader.classList.add('hide'));

    const firstNav=$('.nav-links a[href="#noutati"]');
    if(firstNav) firstNav.textContent='Acasă';

    const promise=$$('.promise > div');
    if(promise[0]) promise[0].innerHTML='<a href="/pages/livrare">Livrare în România</a>';
    if(promise[2]){
      promise[2].innerHTML='<a href="/pages/retur" title="Conform condițiilor de retur și legislației aplicabile">Retur în 14 zile*</a>';
    }

    text($('#shopKicker'),'Selecții NUVRA');
    text($('#shopTitle'),'Parfumuri arabești alese pentru caracter.');

    const originalReset=window.resetProducts;
    if(typeof originalReset==='function'){
      window.resetProducts=function(){
        const out=originalReset.apply(this,arguments);
        text($('#shopKicker'),'Selecții NUVRA');
        text($('#shopTitle'),'Parfumuri arabești alese pentru caracter.');
        return out;
      };
    }
    const originalShowAll=window.showAllProducts;
    if(typeof originalShowAll==='function'){
      window.showAllProducts=function(){
        const out=originalShowAll.apply(this,arguments);
        text($('#shopKicker'),'Colecția completă');
        text($('#shopTitle'),'Toate parfumurile din selecția NUVRA.');
        return out;
      };
    }

    const links=$$('.footer a');
    const by=t=>links.find(a=>a.textContent.trim()===t);
    const news=by('Noutăți');
    if(news){news.textContent='Colecția NUVRA';news.href='/collections/parfumuri-arabesti'}
    const best=by('Bestsellers');
    if(best){best.textContent='Toate parfumurile';best.href='/collections/parfumuri-arabesti';best.onclick=null}
    const categoryLinks={
      'Pentru el':'/collections/parfumuri-pentru-barbati',
      'Pentru ea':'/collections/parfumuri-pentru-femei',
      'Unisex':'/collections/parfumuri-unisex'
    };
    Object.entries(categoryLinks).forEach(([label,url])=>{
      const a=by(label);if(a){a.hidden=false;a.href=url}
    });
    const socialText=$('.footer-bottom span:last-child');
    if(socialText) socialText.textContent='office@nuvra.ro';

    const mobile=$('#mobileMenu');
    if(mobile&&!mobile.querySelector('[data-nuvra-category]')){
      const small=$('small',mobile);
      Object.entries(categoryLinks).forEach(([label,url])=>{
        const a=document.createElement('a');
        a.href=url;a.textContent=label;a.dataset.nuvraCategory='1';
        if(small) mobile.insertBefore(a,small); else mobile.appendChild(a);
      });
    }

    const modalNotes=$('#modalNotes');
    if(modalNotes){modalNotes.textContent='';modalNotes.hidden=true}
    const modal=$('#productModal');
    if(modal&&modalNotes){
      new MutationObserver(()=>{modalNotes.textContent='';modalNotes.hidden=true}).observe(modal,{attributes:true,attributeFilter:['class']});
    }
  }

  function productCro(){
    const main=$('#MainContent[data-template="product"]');
    if(!main)return;

    const buy=$('.buy-buttons-block',main);
    if(buy&&!$('.nuvra-pdp-trust',main)){
      const box=document.createElement('div');
      box.className='nuvra-pdp-trust';
      box.setAttribute('role','note');
      box.innerHTML='<div class="nuvra-pdp-trust__item"><span class="nuvra-pdp-trust__icon">✓</span><span><strong>Livrare în România.</strong> Costul și opțiunile disponibile se afișează în checkout.</span></div><div class="nuvra-pdp-trust__item"><span class="nuvra-pdp-trust__icon">↺</span><span><a href="/pages/livrare">Detalii livrare</a> · <a href="/pages/retur">Retur și dreptul de retragere</a></span></div>';
      buy.insertAdjacentElement('afterend',box);
    }

    $$('h1,h2,h3,h4,h5,h6',document).forEach(h=>{
      const t=h.textContent.replace(/\s+/g,' ').trim();
      if(/^You may also like/i.test(t)) h.textContent='S-ar putea să-ți placă și';
      if(t==='Disclosures') h.textContent='Detalii produs';
    });
  }

  function init(){
    if($('#loader')||$('.nuvra-page')) homeCro();
    productCro();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
